import script from "./SailingStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./SailingStatus.vue?vue&type=script&setup=true&lang=ts"

import "./SailingStatus.vue?vue&type=style&index=0&id=6330f862&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6330f862"]])

export default __exports__